<app-view-title [showBack]="false" [showHeader]="this.userClosed" mode="split" webMode="primary"></app-view-title>

<view-content [centered]="true" [nopadding]="true">
  @if(appSettings.appType !== 'web') {
  <content-header>
    <img class="logo" src="/Styles/{{appSettings.settings.theme}}/Logo.png" />
    <br />
    <p>{{'Intellitrailer.SelectFamily.txtWelcomeMessage.' + appSettings.settings.theme | translate: 'Welcome to ' + appSettings.settings.theme + '!'}}</p>
    <h1>{{'Intellitrailer.SelectFamily.txtSelectType' | translate: 'Select trailer type'}}</h1>
  </content-header>
  }

  @if(loading) {
  <div class="family-type-spinner">
    <mat-spinner diameter="70"></mat-spinner>
  </div>
  }
  @else
  {
  <data-list>
      <app-card web-content *ngFor="let type of filterdCategoryList" (click)="selectType(type)">
        <img src="{{ type.ImageUri }}" />
        <h2>{{'Intellitrailer.SelectFamily.txtFamilyName_' + type.Id | translate: type.Name }}</h2>
        <small>{{'Intellitrailer.SelectFamily.txtFamilyDescription_' + type.Id | translate: type.Description}}</small>
        <div class="title-with-divider"></div>
        <button mat-raised-button>{{ 'tIntellitrailer.Booking.Components.BookingOption.Select' | translate : 'Select'}}</button>
      </app-card>


      <list-item mobile-content *ngFor="let type of filterdCategoryList" (click)="selectType(type)">
        <img src="{{ type.ImageUri }}" />
        <div>
          <h2>{{'Intellitrailer.SelectFamily.txtFamilyName_' + type.Id | translate: type.Name }}</h2>
          <small>{{'Intellitrailer.SelectFamily.txtFamilyDescription_' + type.Id | translate: type.Description}}</small>
        </div>
      </list-item>
  </data-list>



  <button type="button" color="accent" mat-button (click)="skip()"> <mat-icon>map</mat-icon>{{'Intellitrailer.SelectFamily.txtAllTrailers' | translate: 'All trailers'}}</button>
  }
</view-content>


<view-actions *ngIf="typeSettings.isShowMenu">
  <button type="button" mat-raised-button color="accent" (click)="mybooking()">{{'Intellitrailer_Home_Home_cmdMyPage' | translate: 'My reservations'}}</button>
  <div (click)="toggleNewUserInfo(false)" class="link">{{'Intellitrailer_Home_Home_HowDoesItWork' | translate: 'How does it work?' }}</div>
</view-actions>
<app-new-user-info class="new-user-info d-flex align-items-center" *ngIf="!userClosed && typeSettings.isShowGuide" (showInfo)="toggleNewUserInfo($event)"></app-new-user-info>

